<template>
    <div>
        <label for="categories" class="sr-only">All Categories</label>
        <select class="form-control" v-model="selectedCategory" id="categories">
            <option value="" selected="selected">All Categories</option>
            <option v-for="category in categories"
                    v-bind:value="category">
                {{category.name}}
            </option>
        </select>
    </div>
</template>

<script>
  export default {
    props: ['initial'],
    data: function () {
      return {
        selectedCategory: "",
        categories: window.categoryList,
      };
    },
    watch: {
      selectedCategory: function (newCategory, oldCategory) {
        if(this.initial !== newCategory) {
          this.$emit('change:categoryfilter', newCategory);
        }
      },
      initial: function(newInitial, oldInitial) {
        console.log('new initial value');
        if(this.initial != this.selectedCategory) {
          this.selectedCategory = this.initial;
        }
      }
    },
    mounted: function() {
      if(this.initial) {
        this.selectedCategory = this.initial;
      }
    }
  }
</script>
